module.exports = __webpack_public_path__ + "static/media/Infobox.8b132626.pdf";